import React from 'react';
import { FieldProps } from 'formik';
import { Options } from 'react-select';
import Select from './Select';

interface Props extends FieldProps {
  useValue?: boolean;
  options: Options<{ [key: string]: any }>;
  onChange?(option: any | null): void;
}

const getValue = (options, { value }) => {
  return (
    options.find(option => value === option.value) ||
    options.reduce((v, option) => {
      if (v) {
        return v;
      }

      if (option.options) {
        return option.options.find(o => o.value === value);
      }
      return v;
    }, null)
  );
};

const FormikReactSelect = ({ field, form, useValue, options, onChange, ...props }: Props) => {
  const handleOnChange = option => {
    if (!onChange) {
      form.setFieldValue(field.name, useValue ? option.value : option);
    } else {
      onChange(useValue ? option.value : option);
    }
  };

  const value = useValue ? getValue(options, field) : field.value;

  return <Select {...field} {...props} options={options} value={value} onChange={handleOnChange} />;
};

export default FormikReactSelect;
